module.exports = __webpack_public_path__ + "img/1 (70).1395155d.png";